import produce from "immer"
import { PUBLISHED, ASC, TYPE_A, PROVEN_NO } from "const"
import { SilDevice, SilProjectDevice } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initSilDevice: SilDevice = {
    id: null,
    accountId: null,
    manufacturer: "",
    name: "",
    logoId: null,
    description: "",
    reference: "",
    nested: false,
    type: TYPE_A,
    lowDemandMode: true,
    highDemandMode: false,
    continuousMode: false,
    logicSolver: false,
    provenInUse: PROVEN_NO,

    failureRate: false,
    sff: null,
    dc: null,
    pfd: null,
    pfh: null,
    sil: null,

    sd: null,
    su: null,
    dd: null,
    du: null,

    status: PUBLISHED,
    copy: 0,
    updated: false,
}

export const initSilProjectDevice: SilProjectDevice = {
    id: null,
    projectId: null,
    deviceId: null,

    qidProductId: null,
    qidModelId: null,
    qidSafetyFunctionId: null,
    qidOptionId: null,
    qidDatapointId: null,
    qidMethod: null,

    qidModelName: null,
    qidSafetyFunctionName: null,
    qidOptionName: null,
    qidDatapointDate: null,

    manufacturer: "",
    name: "",
    logoId: null,
    description: "",
    reference: "",
    nested: false,
    type: TYPE_A,
    lowDemandMode: true,
    highDemandMode: false,
    continuousMode: false,
    logicSolver: false,
    provenInUse: PROVEN_NO,

    failureRate: false,
    sff: null,
    dc: null,
    pfd: null,
    pfh: null,
    sil: null,

    sd: null,
    su: null,
    dd: null,
    du: null,

    status: PUBLISHED,
    copy: 0,
    updated: false,
}

const initSilDeviceState: types.SilDeviceState = {
    baseDeviceRoute: null,
    baseSubsystemRoute: null,

    deviceList: {},
    deviceIds: [],
    deviceView: initSilDevice,
    deviceEdit: initSilDevice,

    nested: {
        currentDeviceList: [],
        newDeviceList: [],
    },

    sortColumn: "name",
    sortOrder: ASC,
    filters: {
        search: null,
    },

    reloadList: true,
    reloadView: true,
    reloadEdit: true,
}

const silDeviceReducer = produce((
    draft: types.SilDeviceState = initSilDeviceState,
    action: ActionTypes = null,
): types.SilDeviceState => {
    switch (action.type) {
        case types.SIL_DEVICE_BASE_ROUTE:
            draft.baseDeviceRoute = action.baseDeviceRoute
            draft.baseSubsystemRoute = action.baseSubsystemRoute
            return draft

        case types.SIL_DEVICE_LIST:
            draft.deviceList = action.deviceList
            return draft

        case types.SIL_DEVICE_IDS:
            draft.deviceIds = action.deviceIds
            return draft

        case types.SIL_DEVICE_VIEW:
            draft.deviceView = action.device
            return draft

        case types.SIL_DEVICE_EDIT:
            draft.deviceEdit = action.device
            return draft

        case types.SIL_DEVICE_NESTED_CURRENT_LIST:
            draft.nested.currentDeviceList = action.deviceList
            return draft

        case types.SIL_DEVICE_NESTED_NEW_LIST:
            draft.nested.newDeviceList = action.deviceList
            return draft

        case types.SIL_DEVICE_SORT:
            draft.sortColumn = action.sortColumn
            draft.sortOrder = action.sortOrder
            return draft

        case types.SIL_DEVICE_FILTERS:
            draft.filters = action.filters
            return draft

        case types.SIL_DEVICE_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.SIL_DEVICE_RELOAD_VIEW:
            draft.reloadView = action.value
            return draft

        case types.SIL_DEVICE_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default silDeviceReducer
